import { useEffect, useRef, useState } from "react";
import { driver } from "driver.js";
import type { DriveStep, Driver } from "driver.js";
import { useLocation } from "react-router-dom";
import { MagnifyingGlassIcon } from "../Icons";

const dashboardSteps: DriveStep[] = [
  // {
  //   element: "#xflow-vban-card",
  //   popover: {
  //     title: "Welcome",
  //     description: "View your Account Info in USD",
  //   },
  // },
  // {
  //   element: "#euro-account",
  //   popover: {
  //     title: "Next Step",
  //     description: "View your Account Info in Euro",
  //   },
  // },
  {
    element: "#receivable-chart",
    popover: {
      title: "Next Step",
      description: "View your Recievables here",
    },
  },
  {
    element: "#transactions-info",
    popover: {
      title: "Next Step",
      description:
        "View your Info related to your transactions,You can view details about Drafts,Quotes,Ongoing Orders History Details.",
    },
  },
  {
    element: "#dashboard-task",
    popover: {
      title: "Next Step",
      description: "View your tasks!",
    },
  },
  {
    element: "#dashboard-partner-companies",
    popover: {
      title: "Next Feature",
      description: "Add New or View your existing Partners",
    },
  },
  {
    element: "#dashbaord-create-order",
    popover: {
      title: "Next Step",
      description: "Create Orders For Deal Tracker",
    },
  },
  // {
  //   element: "#payment-draft",
  //   popover: {
  //     title: "Next Feature",
  //     description: "Add or View Partners",
  //   },
  // },
];

const paymentSteps: DriveStep[] = [
  {
    element: "#total-amount-card",
    popover: {
      title: "Account",
      description: "View your Account info section.",
    },
  },
  {
    element: "#sp-payment-estimate",
    popover: {
      title: "Payment Estimate",
      description: "View Payment estimatation.",
    },
  },
  {
    element: "#sp-features",
    popover: {
      title: "Feature",
      description: "View your Features info section.",
    },
  },
];

const invoiceSteps: DriveStep[] = [
  {
    element: "#invoice-factoring-pricing-estimate",
    popover: {
      title: "Pricing Estimation",
      description:
        "Enter amount, days and yearly turnover to check pricing estimation",
    },
  },
  {
    element: "#invoice-factoring-features",
    popover: {
      title: "Features",
      description: "Check the features TARAM is offering",
    },
  },
  {
    element: "#invoice-factoring-how-it-works",
    popover: {
      title: "How it works",
      description: "Check how invoice factoring works",
    },
  },
];

const logisticsSteps: DriveStep[] = [
  {
    element: "#fcl-quotes",
    popover: {
      title: "Live FCL Quotes",
      description: "View your FCL Quotes.",
    },
  },
  {
    element: "#logistics-features",
    popover: {
      title: "Features",
      description: "View Features",
    },
  },
];

const qualityAssuranceSteps: DriveStep[] = [
  {
    element: "#quality-pricing-estimate",
    popover: {
      title: "Pricing Estimate",
      description: "View Pricing Estimate",
    },
  },
  {
    element: "#quality-features",
    popover: {
      title: "Features",
      description: "View Features.",
    },
  },
  {
    element: "#quality-how-it-works",
    popover: {
      title: "How it works",
      description: "How Quality Assurance Works",
    },
  },
];

const dealTrackerSteps: DriveStep[] = [
  {
    element: "#create-new-flow-template-btn",
    popover: {
      title: "Create New Flow Template",
      description: "You can create a custom trade flow steps",
    },
  },
  {
    element: "#flow-template-carousel",
    popover: {
      title: "All flow template list",
      description:
        "This contains all the default flow templates and also you can add new custom templates",
    },
  },
  {
    element: "#add-deal-tracker-table",
    popover: {
      title: "Add a table",
      description: "You can add a new deal tracker table",
    },
  },
];

function getSteps(path: string) {
  switch (path) {
    case "/dashboard":
      return dashboardSteps;
    case "/simple-payment":
      return paymentSteps;
    case "/invoice-factoring":
      return invoiceSteps;
    case "/logistics":
      return logisticsSteps;
    case "/quality-assurance":
      return qualityAssuranceSteps;

    case "/deal-tracker":
      return dealTrackerSteps;

    default:
      return null;
  }
}

export default function Tour() {
  const driverRef = useRef<Driver | null>(null);
  const [showTour, setShowTour] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    setShowTour(true);
    const steps = getSteps(pathname);

    if (!steps) {
      setShowTour(false);
      return;
    }

    driverRef.current = driver({
      showProgress: true,
      steps,
      animate: true,
    });

    return () => driverRef.current?.destroy();
  }, [pathname]);

  const startTour = () => {
    if (driverRef.current) {
      driverRef.current.drive();
    }
  };

  return (
    <button
      className={`pl-4 pb-2 w-full flex items-center gap-3 hover:underline border-b border-b-[#c8c8c8] ${
        showTour ? "visible" : "hidden"
      }`}
      onClick={startTour}
    >
      <span>
        <MagnifyingGlassIcon className="size-6 text-black/50" />
      </span>
      <span className="sidebar_label">Start Tour</span>
    </button>
  );
}
